import { ca } from '@cian/analytics';

export function trackCPD1000Click() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'Click',
    label: 'cpd1000_banner',
  });
}

export function trackCPD1000BannerShow() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'show_sopr',
    label: 'cpd1000_banner',
  });
}
